import { useEffect, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import AppLayout from '../../Layouts/AppLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Progress } from '@/components/ui/progress';
import { useGroupOfPeople } from '../../../hooks/useGroupOfPeople';
import { useAlert } from '../../../hooks/useAlert';
import GroupOfPeopleTable from './Table';
import Paginator from '../../Paginator';
import { deleteGroup } from '../../../services/groupsOfPeopleService';

const GroupOfPeople = () => {
  const [isLargerThan1280, setIsLargerThan1280] = useState(window.innerWidth >= 1280);
  const {
    data,
    loading,
    setSearchText,
    searchText,
    fetchData,
    links,
    currentPage
  } = useGroupOfPeople();

  const { questionAlert, successAlert, errorAlert } = useAlert();

  useEffect(() => {
    const handleResize = () => setIsLargerThan1280(window.innerWidth >= 1280);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearchClick = () => {
    fetchData(true);
  }

  useEffect(() => fetchData(true), []);

  const handleDeleteClick = (id) => {
    questionAlert({
      title: 'Eliminar Grupo',
      text: '¿Está seguro que desea eliminar el grupo de personas?',
      icon: 'question',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(r => {
      if (r.isConfirmed) {
        deleteGroup(id)
          .then(r => {
            successAlert({ message: 'Grupo eliminado con éxito' });
            fetchData(true);
          }).catch(err => {
            errorAlert({
              title: 'Error al eliminar grupo',
              exception: err
            });
          });
      }
    });
  }

  return (
    <AppLayout
      title="Grupo de Personas"
      prevButtonVisible
    >
      <div className="bg-white rounded shadow-md">
        <div>
          <div
            className={`px-2 py-2 flex flex-row justify-between items-center flex-wrap ${loading ? 'hidden' : 'flex'}`}
          >
            <div className="flex gap-2">
              <Button
                asChild
                variant="default"
                className="font-semibold text-sm"
              >
                <ReactRouterLink to="/crear-grupo-personas">
                  Nuevo Grupo
                </ReactRouterLink>
              </Button>
            </div>
            <div className="flex items-center py-2">
              <Input onChange={(e) => setSearchText(e.target.value)} value={searchText} />
              <Button onClick={handleSearchClick} className="ml-4 px-5" loading={loading}>Buscar</Button>
            </div>
          </div>
        </div>
        {loading && <Progress value={undefined} className="h-1" />}
        <div className={isLargerThan1280 ? 'bg-white' : ''}>
          <GroupOfPeopleTable
            loading={loading}
            data={data}
            currentPage={currentPage}
            onDelete={handleDeleteClick}
          />
          <Paginator links={links} />
        </div>
      </div>
    </AppLayout>
  );
}

export default GroupOfPeople;
